import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

// SERVICE
import { pCtContractInvolvedUpdate } from "../../../service/400/P416Service";

export default function P416({ dialog, setDialog, onGetpCtContractInfo }) {
    const [errData, setErrData] = useState(null);
    const [formObject, setformObject] = useState({ contractNo: "", involvedName: "", involvedDesc: "", involvedTelephone: "", involvedId: 0 });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    // DIALOG
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // DropDown

    useEffect(() => {
        if (dialog.dialog_416.open === true) {
            setformObject({ ...formObject, ...dialog.dialog_416.dataSet, userId: dialog.dialog_416.userId, contractNo: dialog.dialog_416.contractNo });
        }
    }, []);

    const setViewForm = (key) => {
        return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    const setValueForm = (key, val) => {
        setformObject({ ...formObject, [key]: val });
    };

    const validation = (object, act) => {
        if (act === "D") {
            return true;
        } else {
            if (object.involvedName === "" || object.involvedDesc === "" || object.telephone === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }
    };
    const handlerCloseDialog = () => {
        setDialog({ ...dialog, dialog_416: { open: false, action: "", dataSet: null } });
    };
    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    console.log(dialog);
    const submitForm = (act) => {
        if (validation(formObject, act)) {
            const req = {
                actionCode: act,
                contractNo: setViewForm("contractNo"),
                involvedDesc: setViewForm("involvedDesc"),
                involvedId: setViewForm("involvedId"),
                involvedName: setViewForm("involvedName"),
                telephone: setViewForm("involvedTelephone"),
                userId: setViewForm("userId"),
            };
            console.log(req);
            pCtContractInvolvedUpdate(req).then(
                (res) => {
                    setLoading(false);
                    handlerSettingDialogConfirm(res[0].statusCode === "C" ? "" : "", res[0].statusText);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const onHide = () => {
        handlerCloseDialog();
        setformObject({});
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            submitForm("D");
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
            onGetpCtContractInfo();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(dialog.dialog_416.action === "EDIT" ? "U" : "A")} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-ban" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
                <Button label="ลบรายการ" icon="pi pi-trash" onClick={() => setDeleteDialog({ open: true })} className="p-button-danger p-button" disabled={dialog.dialog_416.action === "EDIT" ? false : true} />
            </div>
        );
    };

    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />
            <Dialog header="บุคคลที่เกี่ยวข้อง" visible={dialog.dialog_416.open} style={{ width: "55vw" }} footer={renderFooter()} onHide={() => onHide()} blockScroll={true} className="p-fluid" maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>
                            เลขที่สัญญา<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText value={formObject.contractNo} maxLength="500" disabled={true} />
                    </div>
                    <div className="p-col-6">
                        <label>
                            ชื่อ-นามสกุล<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText className={submitted && !formObject.involvedName ? "p-invalid" : ""} placeholder="ระบุ ชื่อ-นามสกุล" value={setViewForm("involvedName")} onChange={(e) => setValueForm("involvedName", e.target.value)} maxLength={200} />
                        {submitted && !formObject.involvedName && validateInputText("involvedName", "ชื่อ-นามสกุล")}
                    </div>
                    <div className="p-col-6">
                        <label>
                            ความเกี่ยวข้อง<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText className={submitted && !formObject.involvedDesc ? "p-invalid" : ""} placeholder="ระบุ ความเกี่ยวข้อง" value={setViewForm("involvedDesc")} onChange={(e) => setValueForm("involvedDesc", e.target.value)} maxLength={200} />
                        {submitted && !formObject.involvedDesc && validateInputText("involvedDesc", "ความเกี่ยวข้อง")}
                    </div>
                    <div className="p-col-6">
                        <label>
                            เบอร์โทรศัพท์<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText className={submitted && !formObject.involvedTelephone ? "p-invalid" : ""} placeholder="ระบุ เบอร์โทรศัพท์" value={setViewForm("involvedTelephone")} onChange={(e) => setValueForm("involvedTelephone", e.target.value)} maxLength={100} />
                        {submitted && !formObject.involvedTelephone && validateInputText("involvedTelephone", "เบอร์โทรศัพท์")}
                    </div>
                </div>
            </Dialog>
            <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="ยืนยันเพื่อลบรายการ หรือกดยกเลิกเพื่อยกเลิกการทำรายการ" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
